// src/components/CollectionList.jsx
import aurusСollectionImg1 from '../../assets/img/Aurus/collection/c1.jpg';
import aurusСollectionImg2 from '../../assets/img/Aurus/collection/c2.jpg';

const collections = [
  {
    name: "Мгновенный комфорт",
    img: aurusСollectionImg1,
    link: "#",
  },
  {
    name: "Высочайшая производительность",
    img: aurusСollectionImg2,
    link: "#",
  },
];

const CollectionList = () => {
  return (
    <section className="bp-block bp-collection">
      <div className="wrapper">
        <h2 className="bp-header-h2">Коллекции</h2>

        <div className="categories-list">
          <div className="categories-list__wrapper">
            {collections.map((collection, idx) => (
              <div className="categories-list__item" key={idx}>
                <img
                  src={collection.img}
                  className="categories-list__item-image"
                  alt={collection.name}
                />
                <a href={collection.link} className="categories-list__item-name">
                  {collection.name}
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CollectionList;
